// 开播工具内的适配

// 1080 x 1920
// 1280 x 720
// 1600 x 900
// 1920 x 1080

import { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';
import { useSetState } from 'react-hanger';

const sidebarWidth = 70;

const width = {
  1080: 1080,
  1280: 1280,
  1600: 1600,
  1920: 1920,
};

const BreakPoint = {
  1080: { minWidth: width['1080'], name: '1080' },
  1280: { minWidth: width['1280'], name: '1280' },
  1600: { minWidth: width['1600'], name: '1600' },
  1920: { minWidth: width['1920'], name: '1920' },
};

// Screen Size Hook
const useScreenSize = () => {
  const isClient = typeof window === 'object';

  const { state, setState } = useSetState({
    width: isClient ? window.innerWidth : 0,
    height: isClient ? window.innerHeight : 0,
    screen: BreakPoint['1080'].name,
    portraitScreen: 'default', //1148 = 120+12+598+12+406
  });

  useEffect(() => {
    if (!isClient) {
      return;
    }

    const handleResize = debounce(function () {
      const width = window.innerWidth;
      const height = window.innerHeight;
      let screen = BreakPoint['1080'].name;
      let portraitScreen = 'default';

      if (width < BreakPoint['1280'].minWidth) {
        screen = BreakPoint['1080'].name;
        if (height < 1148) {
          portraitScreen = 'default';
        } else {
          portraitScreen = '1080_Y';
        }
      } else if (
        width >= BreakPoint['1280'].minWidth &&
        width < BreakPoint['1600'].minWidth
      ) {
        screen = BreakPoint['1280'].name;
      } else if (
        width >= BreakPoint['1600'].minWidth &&
        width < BreakPoint['1920'].minWidth
      ) {
        screen = BreakPoint['1600'].name;
      } else if (width >= BreakPoint['1920'].minWidth) {
        screen = BreakPoint['1920'].name;
      }
      setState({
        width,
        height,
        screen,
        portraitScreen,
      });
    }, 50);

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return state;
};

export { BreakPoint, width, useScreenSize as default };
